// DonationPoolPublic.js
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { organization } from "../../config";
import axios from "axios";

export default function DonationPoolPublic() {
    const { pid } = useParams(); // pool ID
    const [pool, setPool] = useState(null);
    const [loading, setLoading] = useState(true);
    const [amount, setAmount] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [coverFees, setCoverFees] = useState(false);

    useEffect(() => {
        axios.get(`/api/donation-pools/${pid}/public`)
            .then(res => setPool(res.data))
            .catch(() => setPool(null))
            .finally(() => setLoading(false));
    }, [pid]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!amount || parseFloat(amount) < 1) {
            return alert("Minimum donation is $1");
        }

        setSubmitting(true);
        try {
            const res = await axios.post(`/api/donation-pools/${pid}/donate`, {
                amount_dollars: parseFloat(amount),
                name,
                email,
                message,
                cover_fees: coverFees,
            });
            window.location.href = res.data.checkout_url;
        } catch (err) {
            alert("Failed to start donation session.");
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) return <p className="text-center mt-5">Loading…</p>;
    if (!pool) return <p className="text-center mt-5">Donation pool not found.</p>;

    const raised = (pool.total_raised_cents || 0) / 100;

    return (
        <div className="container my-5" style={{ maxWidth: "700px" }}>
            <div className="text-center mb-2">
                <Link to="/" className="small-link" style={{ color: "#2E5D3A" }}>&larr; {organization.shortName} Website</Link>
            </div>

            <h2 className="mb-3 text-center">{pool.title}</h2>
            {pool.description && (
                <p className="lead text-center">{pool.description}</p>
            )}

            <h5 className="mb-3 text-center">Donate Any Amount</h5>

            <form className="border rounded p-4 mx-auto" style={{ maxWidth: "400px" }} onSubmit={handleSubmit}>
                <div className="mb-2">
                    <input type="number" className="form-control" min="1" step="0.01" placeholder="Amount in USD"
                        value={amount} onChange={e => setAmount(e.target.value)} required />
                </div>
                <div className="mb-2">
                    <input type="text" className="form-control" placeholder="Your name (optional)"
                        value={name} onChange={e => setName(e.target.value)} />
                </div>
                <div className="mb-2">
                    <textarea className="form-control" placeholder="Message (optional)"
                        value={message} onChange={e => setMessage(e.target.value)} />
                </div>
                <small className="text-body-secondary">Stripe, our payment processor, charges us a fee of $0.30 plus 2.9% per transaction. Would you like to cover this fee?</small>
                <div className="form-check mb-3 mt-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="coverFees"
                        checked={coverFees}
                        onChange={(e) => setCoverFees(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="coverFees">
                        I'd like to cover the processing fee
                    </label>
                </div>
                <button className="btn btn-admin w-100" disabled={submitting}>
                    {submitting ? "Redirecting…" : "Donate"}
                </button>
            </form>
        </div>
    );
}
